import { KaleApplicationEvent } from "src/services/RumService/rum-events/base-events";
import { RumEventName } from "src/services/RumService/rum-events/constants";

interface PDCWarningModalActionEvent extends KaleApplicationEvent {
    name: RumEventName.Kale_PDC_Warning_Modal_Action;
    data: EventData;
}

interface EventData {
    action: string;
}

const eventName = RumEventName.Kale_PDC_Warning_Modal_Action;

type PDCWarningModalActionOptions = Pick<PDCWarningModalActionEvent, "data" | "metadata">;
const pdcWarningModalAction = ({ data, metadata }: PDCWarningModalActionOptions): PDCWarningModalActionEvent => ({
    name: eventName,
    metadata,
    data,
});

export const event = pdcWarningModalAction;
export const name = eventName;
export type Options = PDCWarningModalActionOptions;
export type Event = PDCWarningModalActionEvent;
